<template>
  <div v-if="showDialog && props.map" class="dialog">
    <div class="d-flex justify-content-between align-items-start mb-2">
      <h3 class="mb-0">Uložit bod</h3>
      <button
        @click="zavri"
        type="button"
        class="btn-close"
        aria-label="Zavřít"
      ></button>
    </div>

    <div class="mb-3">
      <label class="form-label">Název:</label>
      <input v-model="titulek" required type="text" class="form-control" />
    </div>
    <div class="mb-3">
      <label class="form-label">Popis:</label>

      <div class="mb-3">
        <label class="form-label">Zeměpisná šířka (lat):</label>
        <input
          type="number"
          class="form-control"
          v-model.number="clickedLatLng.lat"
        />
      </div>
      <div class="mb-3">
        <label class="form-label">Zeměpisná délka (lon):</label>
        <input
          type="number"
          class="form-control"
          v-model.number="clickedLatLng.lng"
        />
      </div>
      <textarea v-model="popis" rows="3" class="form-control"></textarea>
    </div>

    <h4>Stát</h4>
    <div class="mb-3">
      <select class="form-select" v-model="selectedCountry">
        <option
          v-for="country in countries"
          :key="country.code"
          :value="country.code"
        >
          {{ country.name }}
        </option>
      </select>
    </div>

    <h4>Vybavení</h4>
    <div class="form-check">
      <input
        type="checkbox"
        v-model="vybava.electricite"
        class="form-check-input"
        id="el"
      />
      <label class="form-check-label" for="el">Elektrina</label>
    </div>
    <div class="form-check">
      <input
        type="checkbox"
        v-model="vybava.wc_public"
        class="form-check-input"
        id="wc"
      />
      <label class="form-check-label" for="wc">WC veřejné</label>
    </div>

    <div class="form-check">
      <input
        type="checkbox"
        v-model="vybava.piscine"
        class="form-check-input"
        id="piscine"
      />
      <label class="form-check-label" for="piscine">Koupaliště</label>
    </div>

    <div class="form-check">
      <input
        type="checkbox"
        v-model="vybava.baignade"
        class="form-check-input"
        id="baignade"
      />
      <label class="form-check-label" for="baignade">Přírodní koupání</label>
    </div>

    <div class="form-check mb-3">
      <input
        type="checkbox"
        v-model="vybava.douche"
        class="form-check-input"
        id="sprcha"
      />
      <label class="form-check-label" for="sprcha">Sprcha</label>
    </div>

    <h4>Fotka</h4>
    <div class="mb-3">
      <input
        type="file"
        accept="image/*"
        @change="zpracujFotku"
        class="form-control"
      />
    </div>

    <button class="btn btn-primary" @click="potvrditBod">Uložit</button>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
import L from "leaflet";
import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";
import { Url } from "../js/class/Url.js";

const nactiMista = inject("Mista.nactiMista");
const hideSidebar = inject("hideSidebar", null);

const toast = inject("toast");

const selectedCountry = ref("cz");
const countries = ref([
  { code: "cz", name: "Česká republika" },
  { code: "sk", name: "Slovensko" },
  { code: "de", name: "Německo" },
  { code: "pl", name: "Polsko" },
  { code: "at", name: "Rakousko" },
]);

const showDialog = ref(false);
const clickedLatLng = ref(null);
const titulek = ref("");
const popis = ref("");
const vybava = ref({
  electricite: false,
  wc_public: false,
  douche: false,
  piscine: false,
  baignade: false,
});
const fotkaSoubor = ref(null);

let marker = null;
const emit = defineEmits(["potvrzeno", "zavreno"]);
const props = defineProps({ map: Object });

function otevri(latlng, zobrazDialog = false) {
  hideSidebar?.();
  clickedLatLng.value = latlng;
  titulek.value = "";
  popis.value = "";
  vybava.value = {
    electricite: false,
    wc_public: false,
    piscine: false,
    baignade: false,
    douche: false,
  };
  fotkaSoubor.value = null;
  showDialog.value = false;

  if (props.map && latlng) {
    if (marker) props.map.removeLayer(marker);

    marker = L.marker(latlng, {
      draggable: true,
      icon: L.icon({
        iconUrl: "/img/leaflet/marker-icon.png",
        iconRetinaUrl: "/img/leaflet/marker-icon-2x.png",
        shadowUrl: "/img/leaflet/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      }),
    }).addTo(props.map);

    marker.on("dragend", () => {
      clickedLatLng.value = marker.getLatLng();
      showDialog.value = true;
    });

    if (zobrazDialog) {
      showDialog.value = true;
    }
  }
}

function zavri() {
  /*
    if (marker && props.map) {
    props.map.removeLayer(marker);
    marker = null;
  }*/
  showDialog.value = false;
}

function zpracujFotku(event) {
  const soubor = event.target.files[0];
  if (!soubor) return;
  fotkaSoubor.value = soubor;
}

async function potvrditBod() {
  if (!clickedLatLng.value) return;

  if (!titulek.value.trim()) {
    toast.value.showToast("Vyplň název", "error"); //toast.value.showToast("Vyplň název", "error");
    return;
  }

  Lc.f("potvrditBod");
  const data = {};
  if (vybava.value.electricite) data.electricite = "1";
  if (vybava.value.wc_public) data.wc_public = "1";

  if (vybava.value.piscine) data.piscine = "1";
  if (vybava.value.baignade) data.baignade = "1";
  if (vybava.value.douche) data.douche = "1";

  const meta = {
    nazev: titulek.value,
    popis: popis.value,
    lat: clickedLatLng.value.lat,
    lon: clickedLatLng.value.lng,
    stat: selectedCountry.value,
    data: data, // vybavení jako JSON objekt
  };

  const formData = new FormData();
  formData.append("meta", JSON.stringify(meta));
  if (fotkaSoubor.value) {
    formData.append("foto", fotkaSoubor.value);
  }
  Lc.log("potvrditBod", meta);

  let url = `${Url.ULOZ_VLASTNI_MISTO_JSON}?json`;

  Lc.log("url", url);

  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) throw new Error("Chyba při odeslání");

    const vysledek = await response.json();
    Lc.log("vysledek", vysledek);

    if (vysledek.stav) {
      toast.value.showToast("Bod úspěšně uložen", "success");
      nactiMista?.();
      emit("potvrzeno", vysledek);
      zavri();
    } else {
      toast.value.showToast(vysledek.err || "Neznámá chyba", "error");
    }
  } catch (err) {
    console.error("Chyba při ukládání:", err);
    const msg = err?.message || "Nepodařilo se uložit bod";
    toast.value.showToast(msg, "error");
  }
}

defineExpose({ otevri, zavri });
</script>

<style scoped>
.dialog {
  position: absolute;
  top: 100px;
  right: 0;
  background: white;
  padding: 1em;
  border: 1px solid #ccc;
  z-index: 999;
  max-width: 400px;
  width: 100%;
  padding-bottom: 6rem;

  @media screen and (min-width: 768px) {
    max-width: 100%;
    right: auto;
    left: 100px;
  }
}
</style>
